import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '../public/public.css'

import axios from 'axios'
import qs from 'qs'

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.requestUrl = 'http://www.hanfeng.shop/api.html'
Vue.prototype.request = function(data,callback){
	data = this.$qs.stringify(data)
	this.$axios.post('http://www.hanfeng.shop/api.html',data,{
		headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
	}).then((res)=>{
		callback(res.data)
	}).catch((err)=>{
		callback(err)
	})
}
Vue.prototype.uploadFile = function(formData,callback){
	this.$axios.post('http://www.hanfeng.shop/api.html',formData).then((res)=>{callback(res.data)}).catch((err)=>{callback(err)})
}
Vue.prototype.globalTest=function(api,type,msg,code){
	console.log(api)
	type!="error"?this.$notify({title: '成功',message: msg,type: type}):(this.$notify.error({title: '提示',message: msg}),code==14007?this.$router.push({path:'/login',query:{type:1}}):console.log('其他类型的错误'))
}
Vue.prototype.getUserInfo = function(callback){
	var userinfo = localStorage.getItem('userInfo')
	if(userinfo==null){
		var data = {
			token:this.token,
			method:"user.info"
		}
		var that = this
		this.request(data,function(res){
			if(res.status){
				var userinfo = {
					"username":res.data.username,
					"avatar":res.data.avatar,
					"id":res.data.id,
					"mobile":res.data.mobile,
					"nickname":res.data.nickname,
					"score":res.data.point,
					"sex":res.data.sex
				}
				callback(userinfo)
			}else{
				that.globalTest('user.info','error',res.msg,res.data)
			}
		})
	}else{
		// this.userinfo = JSON.parse(userinfo)
		callback(JSON.parse(userinfo))
	}
}

Vue.config.productionTip = false

Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
